export const firstLetter = (string: string) => string.toUpperCase().split('')[0];
